import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from "@chakra-ui/react";
import type { BudgetData } from "src/Manager/EventDetail/Nav/Marketing/ManagedCampaigns/components/BudgetSelector";
import GuidedBudgetEditor from "src/Manager/EventDetail/Nav/Marketing/ManagedCampaigns/components/GuidedBudgetEditor";
import { useEffect, useRef, useState } from "react";

type EditBudgetModalProps = {
  isOpen: boolean;
  isSaving?: boolean;
  initialBudget: BudgetData;
  onClose: () => void;
  onSave: (budget: BudgetData) => void | Promise<void>;
};

export default function EditBudgetModal({
  isOpen,
  isSaving = false,
  initialBudget,
  onClose,
  onSave,
}: EditBudgetModalProps) {
  const [budget, setBudget] = useState<BudgetData>(initialBudget);
  const budgetAmountInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!isOpen) return;
    setBudget(initialBudget);
  }, [initialBudget, isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      isCentered
      initialFocusRef={budgetAmountInputRef}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Budget</ModalHeader>
        <ModalBody>
          <VStack align="stretch" spacing={4}>
            <GuidedBudgetEditor
              amountInputRef={budgetAmountInputRef}
              budget={budget}
              onChangeBudgetType={(type) =>
                setBudget((prev) => ({
                  ...prev,
                  type,
                }))
              }
              onChangeBudgetAmount={(amount) =>
                setBudget((prev) => ({
                  ...prev,
                  amount: {
                    amount,
                    currency: prev.amount?.currency ?? "USD",
                  },
                }))
              }
            />
          </VStack>
        </ModalBody>
        <ModalFooter>
          <HStack spacing={3}>
            <Button variant="ghost" onClick={onClose} isDisabled={isSaving}>
              Cancel
            </Button>
            <Button
              bg="gray.900"
              color="white"
              _hover={{ bg: "gray.800" }}
              onClick={() => onSave(budget)}
              isLoading={isSaving}
            >
              Save
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
